import { render, staticRenderFns } from "./ClaimBalance.vue?vue&type=template&id=112cddf3"
import script from "./ClaimBalance.vue?vue&type=script&lang=js"
export * from "./ClaimBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports